import { useMemo } from 'react'
import { pathStanding, type StepStanding } from '@aurora/core'
import { useAuroraStore } from '../../store/auroraStore'
import { childDecks, childMemory, pathPlayed } from '../../store/selectors'
import { useMinute } from '../cards/useCards'

/**
 * Where she stands on her reading path: core's pathStanding over her memory,
 * her path rows and her decks, the same inputs the phone and the agent read.
 */
export function usePath() {
  const memory = useAuroraStore(childMemory)
  const played = useAuroraStore(pathPlayed)
  const decks = useAuroraStore(childDecks)
  const now = useMinute()
  return useMemo(() => pathStanding({ memory, played, now, decks }), [memory, played, now, decks])
}

/**
 * Where one reading-path step stands, for a row that is her copy of it
 * wherever it is listed (an activity card, a reply), so a book the plan
 * names reads locked there exactly when the path shows it locked.
 * Undefined for anything that is not a path step.
 */
export function useStepStanding(a: any): StepStanding | undefined {
  const id = typeof a?.data?.path === 'string' ? (a.data.path as string) : undefined
  const path = usePath()
  return useMemo(() => (id ? path.tracks.flatMap((t) => t.steps).find((s) => s.step.id === id) : undefined), [id, path])
}
